export { default } from "./ScrollScaleHero";
export * from "./ScrollScaleHero";
